var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("line",{"className":"a","x1":"0.75","y1":"23.249","x2":"23.25","y2":"0.749","key":1}),React.createElement("line",{"className":"a","x1":"23.25","y1":"23.249","x2":"0.75","y2":"0.749","key":2})]);
}

Close.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/close.svg
// module id = 1064
// module chunks = 0